import React, {memo} from 'react'
import type {ReasoningMessagePartProps} from '@assistant-ui/react'

import {OmicsMarkdownBody} from './omicsAssistantMarkdown'

/** Flat reasoning markdown inside the Working strip (no per-chunk accordion). */
export const OmicsCoTReasoningChunk: React.FC<Pick<ReasoningMessagePartProps, 'text'>> = memo(({text}) => {
  if (!text.trim()) return null
  return (
    <div className='markdown-content ai-chat-reasoning-chunk omics-cot-reasoning-chunk'>
      <OmicsMarkdownBody markdown={text} className={undefined} />
    </div>
  )
})

OmicsCoTReasoningChunk.displayName = 'OmicsCoTReasoningChunk'
